import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=4e557a3b&scoped=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=ts&"
export * from "./ArticleCard.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=4e557a3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e557a3b",
  null
  
)

export default component.exports